import * as React from 'react';
import LazyPicture from '../LazyPicture/LazyPicture.js';

const ExclusiveBrandsItem = ({ url , image , mobileImage  })=>/*#__PURE__*/ React.createElement("li", {
        className: "exclusive-brands-item"
    }, /*#__PURE__*/ React.createElement("a", {
        className: "exclusive-brands-item__link",
        href: url
    }, /*#__PURE__*/ React.createElement(LazyPicture, {
        className: "exclusive-brands-item__image",
        image: image,
        mobileImage: mobileImage
    })))
;
var ExclusiveBrandsItem$1 = /*#__PURE__*/ React.memo(ExclusiveBrandsItem);

export { ExclusiveBrandsItem$1 as default };
//# sourceMappingURL=ExclusiveBrandsItem.js.map
